var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-page-hero"},[_c('div',{staticClass:"bg-primary print:bg-transparent text-text"},[_c('div',{staticClass:"c-page-hero__main relative flex flex-col >=1024:block"},[_c('div',{class:[
					'c-page-hero__content flex-1',
					'c-page-hero__content--image >=1024:w-1/2',
					'pt-layout-margin pl-layout-margin pr-layout-margin',

					{
						'pb-md >=1024:pb-md2': _vm.image || !_vm.slim,
						'pb-md2': !_vm.image && !_vm.slim,
						'pb-md2': _vm.slim && _vm.$scopedSlots.after,
					} ]},[(_vm.breadcrumb)?_c('PageBreadcrumb',{staticClass:"mb-md print:hidden",attrs:{"data":_vm.breadcrumb}}):_vm._e(),_vm._v(" "),_c('BaseH1',{class:{ '>=1024:w-6/12': !_vm.image },domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.description && _vm.description.length)?_c('div',{class:['text-h3 mt-sm', { '>=1024:w-6/12': !_vm.image }],domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()],1),_vm._v(" "),(_vm.image)?_c('div',{class:[
					'c-page-hero__image',
					'relative w-full bg-primary-medium h-0',
					'>=1024:absolute >=1024:top-0 >=1024:right-0',
					'>=1024:h-full >=1024:flex-1 >=1024:w-1/2' ]},[(_vm.image)?_c('UmbracoImageExt',{class:[
						'absolute w-full h-full',
						'bg-primary-medium >=1024:relative' ],attrs:{"alt":_vm.image.altText,"widths":[
						320,
						480,
						720,
						960,
						1200,
						1440,
						1920,
						1200 * 2,
						1440 * 2,
						1920 * 2 ],"source-url":_vm.image.cropUrl || _vm.image.url,"source-width":_vm.image.width,"source-height":_vm.image.height,"aspect-ratio":1.6,"image-class-names":"object-cover"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.image && !_vm.noFallbackImage)?_c('SvgBridgeIcon',{staticClass:"text-primary-light",class:[
					'relative w-full bg-primary h-0',
					'>=1024:absolute >=1024:bottom-0 >=1024:right-0',
					'>=1024:w-1/2 >=1024:max-h-full >=1024:h-auto' ]}):_vm._e()],1),_vm._v(" "),(_vm.$scopedSlots.after)?_c('div',{class:[
				'px-layout-margin pb-xl print:pb-0',
				{ 'pt-lg': !_vm.slim, 'pt-0': _vm.slim } ]},[_vm._t("after")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }